import sliders from './sliders';
import contactForm from './contact-form';
import timeline from './timeline';
import mobileNav from './mobile-nav';
import cookieConsentManager from './cookie-consent-manager/main';
import summary from './summary';
import jobForm from './job-form';
import buttons from './buttons';
import section from './section';
import hero from './hero';

window.addEventListener('DOMContentLoaded', () => {
  cookieConsentManager();
  mobileNav();
  sliders();
  contactForm();
  jobForm();
  timeline();
  summary();
  buttons();
  section();
  hero();
});
